module.exports = __webpack_public_path__ + "img/open.b428200b.svg";